import {mutations} from './mutations';
import {actions} from './actions';
import {getters} from './getters';

const state = {
    data: {
        feedback: [],
        availableLocales: [],
        phrases: [],
        machineLearning: true,
        createdAt: null,
    },
    feedbackLoading: false,
    feedbackCacheExpires: null,
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

